import { AtlasContext, AtlasProviderProps } from './context'
import { FC } from 'react'
import { initializeAtlasUsage } from '@dtx-company/inter-app/src/utils/atlas/initAtlasUsage'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import useSWR from 'swr'

export const AtlasProvider: FC<AtlasProviderProps> = ({ children }): JSX.Element => {
  const { jwt } = useAuthState()

  const { data } = useSWR(
    () => (jwt ? ['atlas_provider', jwt] : undefined),
    async ([_key, jwt]) => {
      const atlasData = await initializeAtlasUsage(jwt)
      return atlasData
    },
    {
      revalidateOnFocus: false
    }
  )

  const usage = data || {}

  return (
    <AtlasContext.Provider value={{ usage }}>
      <>{children}</>
    </AtlasContext.Provider>
  )
}
